import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Card, Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import {
  createRestaurant,
  fetchRestaurantDetails,
} from "../actions/restaurantActions";
import RestaurantCreation from "../screens/RestaurantCreation";
import { CustomModal } from "./CustomModal";

const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

const StyledCard = styled(Card)`
  margin: 10px 0;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  overflow: hidden;
  border: 0;
`;

const CardTop = styled.div`
  padding: 10px;
  background-color: #faf6e9;
`;

const StyledRow = styled(Row)`
  height: 100%;
  align-items: center;
  width: 100%;
  margin-left: 0;
`;

const StyledCol = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.justify ? props.justify : "start")};
`;

const StyledColForIcons = styled(Col)`
  display: flex;
  align-items: center;
  font-size: 2rem;
  font-weight: bold;
  color: #ee754c;

  white-space: nowrap;
  word-break: keep-all;
  overflow-wrap: normal;

  @media (max-width: 576px) {
    font-size: 1.3rem;
    line-height: 1.1;
  }
`;

const Smallh6 = styled.h6`
  font-size: 0.9rem;
  margin: 0;
  color: #faf6e9;
  font-weight: bold;

  @media (max-width: 576px) {
    font-size: 0.85rem;
  }
`;

const StyledButton = styled.button`
  background-color: #99b0ad;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #7e9895;
  }
  &:active {
    background-color: #6a837f;
  }
  &:disabled {
    background-color: #ccd4d3;
    cursor: not-allowed;
  }

  @media (max-width: 576px) {
    padding: 8px 12px; /* menos padding no mobile */
    font-size: 13px; /* texto menor */
    display: inline-flex; /* mantém conteúdo na mesma linha */
    align-items: center;
    gap: 6px;
    white-space: nowrap; /* evita quebra para a 2ª linha */
    flex-shrink: 0; /* não encolhe abaixo do conteúdo */
  }
`;

function RestaurantsHeader() {
  const firstOption = [
    "Seguir tutorial",
    "Ao criar o restaurante com o tutorial ativado, explicamos como configurar todas as opções ao seu gosto.",
  ];
  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(firstOption);
  const [showHeader, setShowHeader] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const restaurant_sub = useSelector((state) => state.restaurant_subscription);
  const { restaurantSubscription } = restaurant_sub;

  const manager_info = useSelector((state) => state.crudManager);
  const { managerInfo } = manager_info;

  const restaurantList = useSelector((state) => state.restaurantList);
  const { restaurants, isLoading, error } = restaurantList;

  useEffect(() => {
    if (Array.isArray(restaurants) && restaurants.length === 0) {
      setShowModal(true);
    }
  }, [restaurants]);

  const handleCreateRestaurant = () => {
    dispatch(createRestaurant("reset", true));
    dispatch(fetchRestaurantDetails("reset", true));
    if (selectedOption[0] === firstOption[0]) {
      navigate(`/restaurant_creation/${"yes"}/${"null"}/${"null"}`);
    } else {
      navigate(`/restaurant_creation/${"no"}/${"null"}/${"null"}`);
    }
  };

  return (
    <StyledCard className="p-0">
      {showHeader ? (
        <>
          {restaurantSubscription && showHeader ? (
            <CardTop>
              <StyledRow>
                <StyledColForIcons xs={6}>Restaurantes</StyledColForIcons>
                <StyledCol xs={6} justify="flex-end">
                  <ActionButtons>
                    {showHeader && managerInfo?.boss === managerInfo?.user && (
                      <StyledButton onClick={() => setShowModal(true)}>
                        <Smallh6>
                          Novo restaurante
                          <FontAwesomeIcon
                            size="lg"
                            icon={faPlus}
                            style={{ color: "#FAF6E9" }}
                            className="ml-2"
                          />
                        </Smallh6>
                      </StyledButton>
                    )}
                  </ActionButtons>
                </StyledCol>
              </StyledRow>
            </CardTop>
          ) : (
            <CardTop>
              <StyledRow>
                <StyledCol xs={12}>
                  Aplicação em desenvolvimento. Mantenha-se a par das novidades!
                </StyledCol>
              </StyledRow>
            </CardTop>
          )}
        </>
      ) : null}

      <CustomModal
        title={
          Array.isArray(restaurants) && restaurants.length === 0
            ? "Cria o teu primeiro restaurante"
            : "Novo restaurante"
        }
        show={showModal}
        onHide={() => setShowModal(false)}
        removeCloseButton={
          Array.isArray(restaurants) && restaurants.length === 0
        }
        centered={false}
      >
        <RestaurantCreation setRestauranteCreationModal={setShowModal} />
      </CustomModal>
    </StyledCard>
  );
}

export default RestaurantsHeader;
